import type { SessionUser, UiPrefs } from '@khaddi/contracts';

/**
 * Applies prefs to the session user without clobbering anything else: a refresh that landed meanwhile is kept,
 * and a sign-out (or a different account) is never undone by a late save or rollback.
 */
export const withPrefs = (current: SessionUser | null, userId: string, prefs: UiPrefs): SessionUser | null =>
  current && current.id === userId ? { ...current, prefs } : current;
